import React, { Component } from 'react'
import './App.scss'
import './styles/liaison.scss'
import './styles/FontAwesome/fontawesome.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import Router from './routes/Router'
import ErrorBoundary from './ErrorBoundary'

class App extends Component {
  render() {
    return (
      <ErrorBoundary>
        <Router />
      </ErrorBoundary>
    )
  }
}

export default App
